/**
 * ДИАЛОГ НЕ ПЕРЕЖИВАЕТ СТРАНИЦУ, КОТОРАЯ ЕГО ОТКРЫЛА (SCRUM-897).
 *
 * Диалоги вставляют подложку в `document.body`, а смена маршрута меняет содержимое контейнера
 * страницы — значит окно остаётся висеть поверх СЛЕДУЮЩЕЙ страницы. Нашёл это обход кнопок в e2e
 * (прогон 40715337368): открыт выбор пультов, нажат баннер «подтвердите почту» — уход на профиль,
 * и закрытие окна позвало `renderAll` редактора по разметке, которой больше нет.
 *
 * ПОДЛОЖКУ СНЯТЬ МАЛО — ОКНО СЛУШАЕТ ДОКУМЕНТ. Нашёл проверяющий (Линней, вердикт REFUTED по
 * 07768749, B1). Первая версия просто удаляла узлы, а `keydown` на `document` окна вешают сами и
 * снимают только в своём `close()` (`name-prompt-dialog.ts:106`, и так же ещё десяток окон).
 * Поэтому обработчик переживал удаление, и путь был такой: кабинет → меню строки → «Переименовать»
 * → набрать имя → браузерное «Назад» → на следующей странице нажать Enter → райдер переименован
 * МОЛЧА. Проверено в Chromium. То же с «Сохранить копию» в редакторе.
 *
 * ПОЭТОМУ СПЕРВА ESCAPE, ПОТОМ УБОРКА. Escape у всех наших окон означает отмену: окно само
 * вызывает свой `close(undefined)`, снимает свой обработчик и отдаёт промису `undefined` — ничего
 * не фиксируя. Это и есть разница с «нажать за человека ОК»: отмена ничего не решает за него, а
 * оставленный обработчик решал.
 *
 * Удаление оставшихся подложек после этого — страховка для окна, которое Escape не понимает:
 * видимым оно не останется, даже если его обработчик снять нечем.
 *
 * ЧТО СЮДА НЕ ПОПАДАЕТ НАМЕРЕННО: согласие (`consent-overlay`) спрашивается один раз на сессию и к
 * маршруту не привязано; обход редактора снимает сам редактор в своём `dispose`.
 */
const BACKDROP = ".modal-backdrop";

type Host = Pick<ParentNode, "querySelectorAll"> & Pick<EventTarget, "dispatchEvent">;

/** Вызывается оболочкой при смене маршрута, ПОСЛЕ `dispose()` прежней страницы. */
export function closeDialogsLeftOpen(root: Host = document): number {
  // Сперва дать окнам отмениться самим: так уходит и подложка, и обработчик на документе.
  root.dispatchEvent(new KeyboardEvent("keydown", { key: "Escape", bubbles: true, cancelable: true }));
  const left = Array.from(root.querySelectorAll(BACKDROP));
  for (const backdrop of left) backdrop.remove();
  return left.length;
}
